import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/20.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Jedziemy po ryby"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p35,
            }}
            content={
                <div>
                    <p>
                        Gdy docierasz do sadu, Emil czeka już gotowy do drogi.
                    </p>
                    <ul>
                        <li>
                            Zajedziemy do Hornów po ryby. Zostało mi trochę śliwek, zamienimy się z nimi. Nałowili tego na wesele Garfunkela, to i na pewno coś zostało.
                        </li>
                    </ul>
                    <p>
                        Wóz zaczyna grzęznąć w błocie. Mijacie wysokie trawy rosnące wokół drogi, a woda chlupie pod kołami.
                    </p>
                </div>
            }
        />

    );
}